/**
 * Converts a TN of any format into a simple 10-digit string.
 *
 * @module
 *
 * @param {string} tn TN
 * @param {Boolean} [allowVanity] Whether to allow letters (for vanity numbers) in output
 * @param {Boolean} [truncateVanity] Whether to remove extra letters from the end of vanity numbers
 * @returns {string} simple 10-digit TN
 *
 * @example
 * import { stripTn } from '@somosengineering/js-util-lib';
 *
 * stripTn('+1(303)213-1000');
 * // '3032131000'
 *
 * stripTn('1-800-FLOWERS', true);
 * // '800FLOWERS'
 */
const stripTn = (tn, allowVanity, truncateVanity) => {
   if (allowVanity) {
      const vanityTn = tn.replace(/^\+?1|[^\da-z]/gi, '');
      return truncateVanity
         ? vanityTn.replace(/^(.{10})([a-z]+)$/i, (match, p1) => p1)
         : vanityTn;
   }
   return tn.replace(/^\+?1|[^\d]/g, '');
};

export { stripTn };
